/**
 * MUI Select for RMA warranty status.
 *
 * Reads from the WarrantyStatus entity slice (pre-loaded by ProcessReturnForm's
 * useRmaReferenceData hook). Non-obsolete entries only, sorted by id,
 * unless the current value matches an obsolete entry (shown for backward compat).
 */

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { warrantyStatusSelector } from '@sophocles/entities/WarrantyStatus';

/**
 * @param {object} props
 * @param {number|string|null} props.value
 * @param {function} props.onChange  - (newValue) => void
 * @param {string} [props.label]
 */
export default function WarrantyStatusSelect({ value, onChange, label }) {
  const { t } = useTranslation();
  const raw = useSelector(warrantyStatusSelector);
  const options = raw
    .sortBy(e => e.get('id'))
    .toList()
    .filter(e => !e.get('obsolete', false) || value == e.get('id'));
  const resolvedLabel = label ?? t('rma.warrantyStatus', 'Warranty');

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{resolvedLabel}</InputLabel>
      <Select value={value ?? ''} label={resolvedLabel} onChange={e => onChange(e.target.value || null)}>
        <MenuItem value="">
          <em>{t('rma.none', 'None')}</em>
        </MenuItem>
        {options.toArray().map(entry => (
          <MenuItem key={entry.get('id')} value={entry.get('id')}>
            {entry.get('name')}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
